import request from "@/utils/request";

export async function listGeneral() {
  return (await request.get('/settings?category=GENERAL')).data.data;
}